import { render, staticRenderFns } from "./NotificationBankWithdraw.vue?vue&type=template&id=07701e90"
import script from "./NotificationBankWithdraw.vue?vue&type=script&lang=js"
export * from "./NotificationBankWithdraw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports